import React from 'react';

import { citations, substances, tgitems } from '@Constants';

import AvailableRelativeContextButton from './AvailableRelativeContextButton';

export default function ReactionsRelativeContextsList(props) {
  const { availableRelativeContext } = props;

  const citationsItem = availableRelativeContext.get(citations);
  const substancesItem = availableRelativeContext.get(substances);
  const tgitemsItem = availableRelativeContext.get(tgitems);

  return (
    <>
      {citationsItem && (
        <>
          <span className="u-els-display-none@desktop">out of&nbsp;</span>
          <AvailableRelativeContextButton {...props} item={citationsItem} />
        </>
      )}
      {substancesItem && (
        <>
          ,<span className="u-els-display-none@desktop">&nbsp;containing</span>
          &nbsp;
          <AvailableRelativeContextButton {...props} item={substancesItem} />
        </>
      )}
      {tgitemsItem && (
        <>
          ,&nbsp;
          <AvailableRelativeContextButton {...props} item={tgitemsItem} />
        </>
      )}
    </>
  );
}
